const middleware = {}

middleware['user-agent'] = require('../src/middleware/user-agent.js')
middleware['user-agent'] = middleware['user-agent'].default || middleware['user-agent']

export default middleware
